import api from './index'
import { axios } from '@/utils/request'

export function createDatetimeVocabulary(parameter) {
  return axios({
    url: api.BaseURL + api.DatetimeVocabulary+ 'create',
    method: 'POST',
    data: parameter
  })
}

export function getListDatetimeVocabulary(parameter) {
  console.log(parameter)
  return axios({
    url: api.BaseURL + api.DatetimeVocabulary+ 'list',
    method: 'GET',
    params: parameter
  })
}

export function updateDatetimeVocabulary(parameter) {
  return axios({
    url: api.BaseURL + api.DatetimeVocabulary+ 'update',
    method: 'POST',
    data: parameter
  })
}

export function deleteDatetimeVocabulary(parameter) {
  return axios({
    url: api.BaseURL + api.DatetimeVocabulary+ 'delete',
    method: 'POST',
    data: parameter
  })
}